import React from 'react';
import { stepEnum } from '../ChangePricePlanConsts';

const BlockHeadlineComponent = (props) => {
  const { mainText, small = '', description = '', currentStep } = props;
  let className = small.trim() != '' ? ' headline-selecting-new-package' : '';
  if (props.className) {
    className += ' ' + props.className;
  }
  return (
    <div className={`headline-container` + className}>
      {small.trim() != '' && <div className='small-text d-block'>{small}</div>}
      <div
        className={`${currentStep == stepEnum.SELECT_ACCOUNT || currentStep == stepEnum.COMPLETED ? 'margin-top-40' : ''
          } bold main-text d-block`}>
        <span dangerouslySetInnerHTML={{ __html: mainText }} />
      </div>

      {description.trim() != '' && (
        <div className='description-text max-width-440 ml-auto mr-auto d-block'>
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      )}
    </div>
  );
};

export default BlockHeadlineComponent;
